// extracted by mini-css-extract-plugin
export default {"Card":"DashboardCard_Card__WIf28","iconCard":"DashboardCard_iconCard__0nGXI"};